import { GET_COMPATIBLE_EXTRAS } from "@/actions/GET_COMPATIBLE_EXTRAS.ts";
import { createPersonsInputHelper } from "@/components/ReservationSidebar/helpers/createPersonsInputHelper.ts";
import { CompatibleExtrasInput, MandatoryExtra, OptionalExtra } from "@/helpers/types/types.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { useLazyQuery } from "@apollo/client";
import format from "date-fns/format";
import { useCallback } from "react";

export interface GetExtrasResponse {
  compatibleExtras: (MandatoryExtra | OptionalExtra)[];
}
export interface GetExtrasInput {
  input: CompatibleExtrasInput;
}

export const useLazyGetCompatibleExtras = (cartItem: CartAccommodationItem) => {
  const [getCompatibleExtras, { data, loading: getExtrasLoading, previousData }] = useLazyQuery<
    GetExtrasResponse,
    GetExtrasInput
  >(GET_COMPATIBLE_EXTRAS, { fetchPolicy: "no-cache" });

  const startDate = cartItem.dateRange?.[0];
  const endDate = cartItem.dateRange?.[1];

  const handleGetCompatibleExtras = useCallback(async () => {
    if (cartItem.ratePlan && startDate && endDate) {
      try {
        return await getCompatibleExtras({
          variables: {
            input: {
              checkIn: format(new Date(startDate), "yyyy-MM-dd"),
              checkOut: format(new Date(endDate), "yyyy-MM-dd"),
              ratePlanId: cartItem.ratePlan.id,
              persons: createPersonsInputHelper(cartItem.adults, cartItem.children),
            },
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }, [cartItem.adults, cartItem.children, cartItem.ratePlan, endDate, getCompatibleExtras, startDate]);

  return {
    handleGetCompatibleExtras,
    compatibleExtras: data?.compatibleExtras || previousData?.compatibleExtras || [],
    getExtrasLoading,
  };
};
